import { Campaign, Collab } from '@foodfluence/shared';

export const MAX_COUNTERS = 2;

export const canCounter = (campaign: Campaign, collab: Collab): boolean => {
  return campaign?.allowCounters && (collab.counters?.length ?? 0) < MAX_COUNTERS;
};